import { ADDRESS_CHANGE_MODE, ADDRESS_ERROR, ADDRESS_RECEIVE, ORDER_CHANGE_CURRENTPAGE, ORDER_APPROVER_CHANGE_CURRENTPAGE, ORDER_CHANGE_MODE, ORDER_ERROR, ORDER_RECEIVE, ORDER_SET_LIST, ORDER_SET_LOADING_STATUS, ORDER_SET_ORDER, ORDER_SET_REORDER_RESPONSE, ORDER_APPROVER_SET_LIST, ORDER_APPROVER_RECEIVE, ORDER_APPROVER_SET_ORDER, ORDER_APPROVER_CHANGE_MODE, ORDER_APPROVER_SET_APPROVED_RESPONSE, ORDER_APPROVER_SET_REJECTED_RESPONSE, PERSON_CHANGE_MODE, PERSON_ERROR, PERSON_RECEIVE, ORDER_APPROVER_RECEIVE_UPDATED_ORDER, ORDER_APPROVER_SET_ORDER_ACTION, ViewMode } from '../constants';
import { person as personReducer } from './Person.reducer';
import { address as addressReducer } from './Address.reducer';
import { order as orderReducer } from './Order.reducer';
import { orderApprover as orderApproverReducer } from './OrderApprover.reducer';
const defaultState = {
    persons: {
        list: [],
        mode: ViewMode.List,
        errors: {},
    },
    addresses: {
        list: [],
        mode: ViewMode.List,
        errors: {},
    },
    orders: {
        currentPage: 1,
        mode: ViewMode.List,
        list: [],
        order: {},
        totalCount: 0,
        showOnlyMyOrders: false,
        errors: {},
        isLoadingList: true,
        isLoadingDetails: true,
        reOrderResponse: null
    },
    ordersForApprover: {
        mode: ViewMode.List,
        orders: [],
        order: null,
        totalCount: 0,
        errors: {},
        isLoadingList: true,
        isLoadingDetails: true,
        orderApprovedResponse: null,
        orderRejectedResponse: null,
        orderAction: null
    }
};
export const myPage = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PERSON_RECEIVE:
        case PERSON_ERROR:
        case PERSON_CHANGE_MODE:
            return {
                ...state,
                persons: personReducer(state.persons, action),
            };
        case ADDRESS_RECEIVE:
        case ADDRESS_ERROR:
        case ADDRESS_CHANGE_MODE:
            return {
                ...state,
                addresses: addressReducer(state.addresses, action),
            };
        case ORDER_RECEIVE:
        case ORDER_ERROR:
        case ORDER_CHANGE_MODE:
        case ORDER_CHANGE_CURRENTPAGE:
        case ORDER_SET_ORDER:
        case ORDER_SET_LIST:
        case ORDER_SET_LOADING_STATUS:
        case ORDER_SET_REORDER_RESPONSE:
            return {
                ...state,
                orders: orderReducer(state.orders, action),
            };
        case ORDER_APPROVER_RECEIVE:
        case ORDER_APPROVER_SET_LIST:
        case ORDER_APPROVER_SET_ORDER:
        case ORDER_APPROVER_CHANGE_CURRENTPAGE:
        case ORDER_APPROVER_CHANGE_MODE:
        case ORDER_APPROVER_SET_APPROVED_RESPONSE:
        case ORDER_APPROVER_SET_REJECTED_RESPONSE:
        case ORDER_APPROVER_SET_ORDER_ACTION:
            return {
                ...state,
                ordersForApprover: orderApproverReducer(state.ordersForApprover, action),
            };
        case ORDER_APPROVER_RECEIVE_UPDATED_ORDER:
            const { updatedOrder } = payload;
            const updatedOrdersList = state.ordersForApprover.orders.map(order => {
                return order.orderId === updatedOrder.orderId ? updatedOrder : order;
            });
            return {
                ...state,
                ordersForApprover: {
                    ...state.ordersForApprover,
                    orders: updatedOrdersList,
                    order: updatedOrder,
                }
            };
        default:
            return state;
    }
};
